import * as Yup from 'yup'
import { emailRegExpFormat } from './email'

/**
 * ✅ Reusable password rule:
 * - Minimum 8 characters
 * - At least 1 uppercase
 * - At least 1 lowercase
 * - At least 1 number
 * - At least 1 special character
 */
export const passwordRule = (textRequired) =>
  Yup.string()
    .required(textRequired)
    .min(8, 'Password must be at least 8 characters')
    .matches(/[A-Z]/, 'Must include at least one uppercase letter (A-Z)')
    .matches(/[a-z]/, 'Must include at least one lowercase letter (a-z)')
    .matches(/[0-9]/, 'Must include at least one number (0-9)')
    .matches(
      /[!@#$%^&*]/,
      'Must include at least one special character (!@#$%^&*)',
    )

/**
 * ✅ For "Set Password"
 */
export const passwordSchemaValidation = (formatMessage) => {
  const textRequired = formatMessage({
    id: 'composeDialog.field.required',
  })

  return Yup.object({
    password: passwordRule(textRequired),
    confirmPassword: Yup.string()
      .required(textRequired)
      .oneOf(
        [Yup.ref('password'), null],
        'Password not match. Please ensure both fields have same password.',
      ),
  })
}

/**
 * ✅ For "Change Password"
 */
export const changePasswordSchemaValidation = (formatMessage) => {
  const textRequired = formatMessage({
    id: 'composeDialog.field.required',
  })

  return Yup.object({
    currentPassword: Yup.string()
      .required(textRequired)
      .min(
        8,
        formatMessage({ id: 'login.textField.validation.minLengthPassword' }),
      ),

    newPassword: passwordRule(textRequired).notOneOf(
      [Yup.ref('currentPassword')],
      formatMessage({
        id: 'changePassword.validate.sameWithCurrentPassowrd',
      }),
    ),

    confirmPassword: Yup.string()
      .required(textRequired)
      .oneOf(
        [Yup.ref('newPassword'), null],
        'Password not match. Please ensure both fields have same password.',
      ),
  })
}

/**
 * ✅ For "Set New Password"
 */
export const setPasswordSchemaValidation = (formatMessage) => {
  const textRequired = formatMessage({
    id: 'composeDialog.field.required',
  })

  return Yup.object({
    password: passwordRule(textRequired),
    confirmPassword: Yup.string()
      .required(textRequired)
      .oneOf(
        [Yup.ref('password'), null],
        'Password not match. Please ensure both fields have same password.',
      ),
  })
}

/**
 * ✅ Full Name validation
 */
export const fullNameSchemaValidation = (formatMessage) => {
  const textRequired = formatMessage({
    id: 'composeDialog.field.required',
  })

  return {
    firstName: Yup.string()
      .matches(
        /^[^\d]/,
        formatMessage(
          { id: 'validation.notStartNumber' },
          {
            filedName: formatMessage({ id: 'firstName.label' }),
          },
        ),
      )
      .required(textRequired),
    lastName: Yup.string()
      .matches(
        /^[^\d]/,
        formatMessage(
          { id: 'validation.notStartNumber' },
          {
            filedName: formatMessage({ id: 'lastName.label' }),
          },
        ),
      )
      .required(textRequired),
  }
}

/**
 * ✅ Email validation
 */
export const emailSchemaValidation = (formatMessage) => {
  const textRequired = formatMessage({
    id: 'composeDialog.field.required',
  })

  return Yup.string()
    .matches(emailRegExpFormat, 'Invalid email address format')
    .required(textRequired)
}
